require('jquery-ui-dist/jquery-ui');
import * as template from '../components/stringTemplate.js';

$(() => {
  let btnSwitch = $('#chk-switch');

  let btnAddForm = $('.btn-add-form');
  let acordion = $('.accordion');

  let doubleSecurity = async (e) => {
    let el = $(e.currentTarget);
    let mConfirm = '¿Activar la doble seguridad al escanear el código?';
    let mCancel =
      '¿Seguro que desea desactivar la doble seguridad al escanear el código?';

    if (el.is(':checked')) {
      alertCheck(mConfirm);
    } else {
      alertUncheck(mCancel);
    }

    function alertCheck(message) {
      let c = confirm(message);

      if (c) {
        btnSwitch.prop('checked', true);
        sendActivation(true, btnSwitch.data('code'), btnSwitch.data('type'));
      } else {
        btnSwitch.prop('checked', false);
      }
    }

    function alertUncheck(message) {
      let c = confirm(message);

      if (c) {
        btnSwitch.prop('checked', false);
        sendActivation(false, btnSwitch.data('code'), btnSwitch.data('type'));
      } else {
        btnSwitch.prop('checked', true);
      }
    }

    async function sendActivation(s, code, type) {
      // let status = btnSwitch.is(':checked') ? 1 : 0;
      let status = s ? 1 : 0;

      try {
        let response = await fetch('/users/disable-public', {
          method: 'POST',
          headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            public_status: status,
            code: code,
            type: type,
          }),
        });
        // let data = await response.json();
      } catch (error) {
        console.error('error: ', error);
      }
    }
  };

  btnSwitch.on('click', doubleSecurity);

  // ACORDERON
  acordion.on('click', '.btnToggle', function (e) {
    let el = $(this);
    let parent = el.parent();
    let h = parent.next();

    if (parent.hasClass('active')) {
      parent.removeClass('active');
    } else {
      parent.addClass('active');
    }
    h.slideToggle();
  });

  function addForm(e) {
    let el = $(this);
    let parent = el.parents('.accordion');
    let acordionHead = parent.find('.head');
    let formProfile = parent.find('.form-profile');
    let message = parent.find('.message-add-form');

    if (acordionHead.hasClass('active')) {
      message.hide();
      formProfile.show();
    }
    // if (!formProfile.is(':visible')) {}
  }

  $('.btn-add-form').on('click', addForm);

  function cancelForm(e) {
    let form = $(this).parents('.form');
    let c = confirm('¿Está seguro que desea salir sin guardar?');

    if (c) {
      form.hide();
      form.trigger('reset');
    }
  }

  $('.btn-cancel').on('click', cancelForm);

  async function saveForm(e) {
    e.preventDefault();

    let el = $(this);
    let action = el.attr('action');
    let formId = el.attr('id');

    let isValid = el.valid();

    if (isValid) {
      try {
        let response = await fetch(action, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(formObj2Json(el.serializeArray())),
        });

        let data = await response.json();

        formFactory(formId, data, action);

        el[0].reset();
        el.hide();
      } catch (error) {
        console.error('error: ', error);
      }
    }
  }

  $('.form-profile').on('submit', saveForm);

  const formObj2Json = (formArray) => {
    let obj = {};

    for (const prop of formArray) {
      obj[prop.name] = prop.value;
    }

    return obj;
  };

  const formFactory = (id, data, action) => {
    let list = $('#' + id)
      .parent()
      .find('#content-list');
    let item;

    switch (id) {
      case 'form-add-vaccine':
        item = template.vaccine(data.vaccine, action);
        break;

      case 'form-add-allergy':
        item = template.allergy(data.allergy, action);
        break;

      case 'form-add-diseases':
        item = template.diseases(data.seriousDiseases, action);
        break;

      case 'form-add-medication':
        item = template.medication(data.medication, action);
        break;

      case 'form-add-emergency-contacts':
        item = template.emergencyContact(data.emergencyContact, action);
        break;

      case 'form-add-insurance-information':
        item = template.secureInformation(data.secureInformation, action);
        break;

      case 'form-add-family-history':
        item = template.familyHistory(data.familyHistory, action);
        break;

      case 'form-add-additional-information':
        item = template.additionalInformation(
          data.additionalInformation,
          action
        );
        break;

      default:
        break;
    }

    list.append(item);
  };

  async function deleteContentForm(e) {
    let el = $(this);
    let form = el.parent().siblings('.form-content');
    let action = form.attr('action');
    let code = form.find('input[name=code]').val();

    let c = confirm('¿Seguro que desea eliminar?');

    if (c) {
      try {
        let response = await fetch(action, {
          method: 'DELETE',
          headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ code: code }),
        });

        let data = await response.json();

        if (data.success) {
          form.parent().remove();
        }
      } catch (error) {
        console.error('error: ', error);
      }
    }
  }

  $('.content-list').on('click', '.btn-delete', deleteContentForm);

  async function addBtnForm(e) {
    let el = $(this);
    let form = el.parent().siblings('.form-content');
    let formControl = form.find('.form-control');
    let action = form.attr('action');

    let button = `
      <div class="buttons">
        <button class="btn btn-save-edit" type="button">GUARDAR</button>
      </div>
    `;

    if (!form.find('.buttons').length) {
      formControl.removeAttr('disabled');
      form.append(button);
    }
    formControl.first().focus();
  }

  $('.content-list').on('click', '.btn-edit', addBtnForm);

  async function editContentForm(e) {
    e.preventDefault();

    let el = $(this);
    let button = el.parent();
    let form = el.parents('.form-content');
    let formControl = form.find('.form-control');
    let action = form.attr('action');

    let isValid = form.valid();

    if (isValid) {
      try {
        let response = await fetch(action, {
          method: 'PATCH',
          headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(formObj2Json(form.serializeArray())),
        });

        let data = await response.json();

        if (data.success) {
          formControl.attr('disabled', true);
          button.detach();
        }
      } catch (error) {
        console.error('error: ', error);
      }
    }
  }

  if ($('.datepicker').length > 0) {
    $('.datepicker').datepicker({
      showOtherMonths: true,
      selectOtherMonths: false,
      changeMonth: true,
      changeYear: true,
      yearRange: '-100:+0',
      dateFormat: 'dd/mm/yy',
    });
  }

  function datePicker(e) {
    $(this).datepicker({
      showOtherMonths: true,
      selectOtherMonths: false,
      changeMonth: true,
      changeYear: true,
      yearRange: '-100:+0',
      dateFormat: 'dd/mm/yy',
    });
  }

  function previewInputFile(e) {
    const el = $(this);
    const siblings = el.siblings('.preview-img-vacc');

    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = function (e) {
      const blob = reader.result;
      el.siblings('.send-vacc-image').attr('value', blob);
    };
    reader.readAsDataURL(file);

    const image = URL.createObjectURL(file);

    siblings.show();
    siblings.find('img').attr('src', image);
  }

  $('.form-content').on('click', '.datepicker', datePicker);
  $(document).on('click', '.btn-save-edit', editContentForm);
  $('.input-img-vacc').on('change', previewInputFile);
});
